// Simple hash function to generate consistent hash from string
const simpleHash = (str: string): string => {
  let hash = 0;
  if (str.length === 0) return hash.toString();

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32-bit integer
  }

  // Convert to positive number and then to base36 for alphanumeric characters
  return Math.abs(hash).toString(36);
};

export const getDeviceId = () => {
  const fingerprint = {
    screen: `${screen.width}x${screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    userAgent: navigator.userAgent,
    cookieEnabled: navigator.cookieEnabled,
    doNotTrack: navigator.doNotTrack
  };

  // Create a hash from these properties
  const fingerprintString = JSON.stringify(fingerprint);
  const hash = simpleHash(fingerprintString);

  // Ensure we have exactly 8 characters, pad with zeros if needed
  return hash.padEnd(8, '0').substring(0, 8);
};
